module.exports = __webpack_public_path__ + "img/web.2ad7764b.svg";